import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/logo-white.svg'
import _imports_1 from '@/assets/images/icons/chat.svg'
import _imports_2 from '@/assets/images/icons/user.svg'
import _imports_3 from '@/assets/images/icons/logout.svg'
import _imports_4 from '@/assets/images/icons/hamburger.svg'


const _withScopeId = n => (_pushScopeId("data-v-071c08aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "header__logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  class: "header__logo-img"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header__logo-title" }, " Wipon Pro ", -1))
const _hoisted_6 = { class: "nav__list" }
const _hoisted_7 = { class: "nav__list-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "nav__link-icon"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Обратная связь ")
const _hoisted_10 = { class: "nav__list-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "nav__link-icon"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Профиль ")
const _hoisted_13 = { class: "nav__list-item nav__list-logout" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "Menu"
}, null, -1))
const _hoisted_17 = { class: "nav__mobile" }
const _hoisted_18 = { class: "nav__list-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "nav__link-icon"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Обратная связь ")
const _hoisted_21 = { class: "nav__list-item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "nav__link-icon"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Профиль ")
const _hoisted_24 = { class: "nav__list-item nav__list-logout" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "nav__link-icon",
  alt: ""
}, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Выйти ")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FeedbackModal = _resolveComponent("FeedbackModal")!
  const _component_ProfileModal = _resolveComponent("ProfileModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "header__logo-link",
            to: { name: 'main.home' }
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFeedbackModal = true)),
              to: "/",
              class: "nav__link"
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showProfileModal = true)),
              to: "/",
              class: "nav__link"
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createElementVNode("span", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
              class: "nav__link"
            }, _hoisted_15)
          ])
        ]),
        _createElementVNode("div", {
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.showMobileMenu = !_ctx.showMobileMenu), ["stop"])),
          class: "nav__menu"
        }, [
          _hoisted_16,
          _withDirectives(_createElementVNode("ul", _hoisted_17, [
            _createElementVNode("li", _hoisted_18, [
              _createVNode(_component_router_link, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showFeedbackModal = true)),
                to: "/",
                class: "nav__link"
              }, {
                default: _withCtx(() => [
                  _hoisted_19,
                  _hoisted_20
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_21, [
              _createVNode(_component_router_link, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showProfileModal = true)),
                to: "/",
                class: "nav__link"
              }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _hoisted_23
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_24, [
              _createElementVNode("span", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                class: "nav__link"
              }, _hoisted_27)
            ])
          ], 512), [
            [_vShow, _ctx.showMobileMenu]
          ])
        ])
      ])
    ]),
    (_ctx.showFeedbackModal)
      ? (_openBlock(), _createBlock(_component_FeedbackModal, {
          key: 0,
          onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showFeedbackModal = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.showProfileModal)
      ? (_openBlock(), _createBlock(_component_ProfileModal, {
          key: 1,
          onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showProfileModal = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}